import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import PlaceholderText from "../Placeholder/PlaceholderText";
import ListCalendarSchedule from "../../pages/Calendar/ListCalendarSchedule";

const NextClass = () => {
  const { t } = useTranslation();
  const { allClasses } = useSelector((state) => state.genericReducer);

  return (
    <>
      <h2>
        <strong>{t("BTN_UPCOMING_CLASS")}</strong>
      </h2>

      {allClasses?.length > 0 ? (
        allClasses?.map((schedule) => <ListCalendarSchedule key={JSON.stringify(schedule)} schedule={schedule} />)
      ) : (
        <PlaceholderText />
      )}
    </>
  );
};

export default NextClass;
